export default __webpack_public_path__ + "static/bsfi-storm-in-eb6f85b190f9faab9654527107ce3a82.gif";